// RITA-1525 — Die Vertragsarten mit Logo für Werkzeugleiste und Seiten. Probe und Vertragsseite
// laden sie beim Öffnen und stellen sie hier bereit; das Dokument merkt sich
// nur die id der Vertragsart, nie das Bild — ein neues Logo in den Einstellungen erscheint beim
// nächsten Öffnen des Editors, ohne dass eine Vorlage neu gespeichert werden müsste.
// Der Kontext reicht auch durch das Druckportal (React-Portale
// erben den Kontext).
import { createContext, useContext } from 'react';
import type { VertragsartMitLogo, VertragsartenStand } from '../../api/vertragsartenMitLogo';

export const KEINE_VERTRAGSARTEN: VertragsartenStand = { vertragsarten: [], laedt: false, fehler: false };

const VertragsartenKontext = createContext<VertragsartenStand>(KEINE_VERTRAGSARTEN);

export const VertragsartenProvider = VertragsartenKontext.Provider;

export const useVertragsarten = (): VertragsartenStand => useContext(VertragsartenKontext);

/** Die gewählte Vertragsart oder null (nichts gewählt bzw. nicht mehr vorhanden). */
export const vertragsartFinden = (stand: VertragsartenStand, id: number | null): VertragsartMitLogo | null =>
  id === null ? null : (stand.vertragsarten.find((vertragsart) => vertragsart.id === id) ?? null);

/** Texte der Werkzeugleiste. Feldname, Hilfetext und Hinweis ohne Logo: Wortlaut von Julia (28.09.2026). */
export const LOGO_FELDNAME = 'Logo (Vertragsart)';
export const LOGO_HILFETEXT = 'Das Logo kommt aus Einstellungen → Vertragsarten.';
export const LOGO_FEHLT_HINWEIS = 'Diese Vertragsart hat kein Logo. Unter Einstellungen → Vertragsarten hinterlegen.';
/** Sonderfälle; Wortlaut von Julia am 28.09.2026 bestätigt. */
export const VERTRAGSART_UNBEKANNT_HINWEIS = 'Diese Vertragsart gibt es nicht mehr. Bitte eine andere wählen.';
export const VERTRAGSARTEN_LADEN_TEXT = 'Vertragsarten werden geladen …';
export const VERTRAGSARTEN_FEHLER_TEXT = 'Vertragsarten konnten nicht geladen werden.';
export const VERTRAGSART_GESPEICHERT_NICHT_LADBAR = 'Gespeicherte Vertragsart (gerade nicht ladbar)';
